import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';

export const labGuideItemsRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/guide_items',
}).lazy(() =>
  import('pages/lab/GuideItems/LabGuideItemsPage/LabGuideItemsPage').then((d) => d.Route)
);
